// @ts-check

import React, { Component, Fragment } from "react"
import WithRecord from "data/wrappers/WithRecord"
import { text } from "../../attributes/items/primitives"
import { record as recordContext } from "../../ContextProviders"

/**
 * @augments {Component<BlockTypeProps>}
 */
class RecordContainerBlockType extends Component {
    /**
     * @type {(block: BlockConfig, context: BlockContext) => any} validate
     */
    static validate = (block, context) => {
        if (!block.config.attributes.objectId) {
            return "an objectId is required"
        }
    }
    static attributes = []
    render() {
        const { Wrapper } = this.props
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle, evaluateFormulas }) => {
                    const contents = (
                        <div
                            style={computedStyle}
                            className="display-flex flex-column position-relative drop-here"
                        >
                            {this.props.childBlocks.length === 0 ? (
                                this.props.renderDroppable(null)
                            ) : (
                                <Fragment>
                                    {this.props.renderDroppable(
                                        null,
                                        this.props.childBlocks.length
                                    )}
                                    {this.props.utils.renderChildren(this.props.childBlocks)}
                                </Fragment>
                            )}
                        </div>
                    )
                    return (
                        <WithRecord loading={contents} recordId={evaluateFormulas(attrs.recordId)}>
                            {({ record }) => (
                                <recordContext.Provider value={record}>
                                    {contents}
                                </recordContext.Provider>
                            )}
                        </WithRecord>
                    )
                }}
            </Wrapper>
        )
    }
}

RecordContainerBlockType.propTypes = {}

RecordContainerBlockType.attributes = [text({ field: "recordId", label: "Record" })]

export default RecordContainerBlockType



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/data/RecordContainerBlock.js